@for (alert of alerts(); track alert) {
  <div @transform [@.disabled]="disableAnimation()" [ngClass]="['alert alert--' + alert.type, alert?.modifier ? 'alert--' + alert?.modifier : '']" role="alert">
    <div class="alert__icon">
      <icon glyph="{{ alert.icon ? alert.icon : alertIcons[alert.type]}}" size="large"></icon>
    </div>
    <p>
      <span [innerHTML]="alert.message | translate"></span>
      @if (alert.link) {
        <a class="alert__close alert__close--link" [routerLink]="[alert.link.url]" [attr.data-test-id]="'alerts-link-' + (alert?.link?.url | slugify)">{{ alert.link.label }}</a>
      }
    </p>
    @if (alert.type === 'cookie') {
      <div class="cookie__buttons">
        <button htm-button (click)="cookies.agreeTerms()" data-test-id="alerts-cookie-agree-button">{{ 'agree' | translate }}</button>
        @if (alert.closeable) {
          <button attr.aria-label="{{ 'button.close' | translate }}" class="alert__close" (click)="remove(alert)" data-test-id="alerts-cookie-close-button">
            <icon glyph="x" size="medium"></icon>
          </button>
        }
      </div>
    }
    @if (alert.closeable) {
      <button attr.aria-label="{{ 'button.close' | translate }}" class="alert__close" (click)="remove(alert)" data-test-id="alerts-close-button">
        <icon glyph="x"></icon>
      </button>
    }
  </div>
}
